module.exports = __webpack_public_path__ + "img/beian_icon.d0289dc0.png";